import { EstadoI } from "interfaces/general";
import { TipoEfectoI } from "interfaces/TipoEfecto";

export interface infoFetchEstadoI {
  id: number | string;
  nombre: string;
  borderColor: string;
  backgroundColor: string;
  textColor: string;
}

class Estado implements EstadoI {
  id: number | string;
  nombre: string;
  borderColor: string;
  backgroundColor: string;
  textColor: string;

  constructor(infoFetch: infoFetchEstadoI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
    this.borderColor = infoFetch.borderColor;
    this.backgroundColor = infoFetch.backgroundColor;
    this.textColor = infoFetch.textColor;
  }
}

export const makeEstado = (infoFetch: infoFetchEstadoI) => {
  return new Estado(infoFetch);
};
